const getURL = location.pathname.indexOf("default.aspx");
const baseUrl = SITEBASEURL + "p/tickets";
const customUrl = "https://festevents.org/";

if (getURL >= 0 || location.pathname == "/") {
  window.location = baseUrl;
}

$(document).ready(function () {
  $(".generalmessage").prependTo("header");
  $(".header-logo").attr("href", customUrl);
  $(".header-logo").attr("target", "_blank");
});

$(window).on("load", function () {
  // get the a tag with number of tickets in cart
  const cart = $(".cartMenuLink");
  const cartUrl = cart.attr("href");
  const cartTickets = cart.text();
  // create the new cart button
  const newCartUrl =
    cart.text() === "0" ? cartUrl : "https://tickets.festevents.org/cart.aspx";
  const newCartBtn = `
    <a class="viewcart" title="Cart" href=${newCartUrl}>
      Cart: 
      <span class="cartMenuLink" >${cartTickets}</span>
    </a>
  `;
  // replace .viewcart with newCartBtn
  $(".viewcart").replaceWith(newCartBtn);
});
